var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrutturaPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_8010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15L13.464 2.70751C14.4194 1.76416 15.9627 1.76416 16.9328 2.70751L29 14.6227",
    stroke: "#2B318A",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16V25.6858C24 26.6872 23.0043 27.5 21.7908 27.5H8.20916C6.98012 27.5 6 26.6872 6 25.6858V16",
    stroke: "#2B318A",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_8010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "#2B318A",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrutturaPurple);
export default __webpack_public_path__ + "static/media/strutturaPurple.8c06d5e9a87f64c93ee102c097dbad5a.svg";
export { ForwardRef as ReactComponent };